import { CommonModule } from '@angular/common';
import { BaseTitleComponent } from '../base-title/base-title.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-main-title',
  templateUrl: './main-title.component.html',
  styleUrls: ['./main-title.component.scss'],
  imports: [CommonModule],
})
export class MainTitleComponent extends BaseTitleComponent implements OnInit {
  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
